<script>
import { mapState } from 'vuex'
import PetRow from './PetRow.vue'
export default {
  name: 'PetDisplay',
  components: {
    PetRow,
  },
  computed: {
    ...mapState({
      pets: state => state.signup.pets,
      coupons: state => state.coupons,
    }),
  },
}
</script>

<template>
  <v-container v-if="pets.length > 0 && pets[0].name != ''" class="petcontainer px-12">
    <v-row>
      <v-col cols="10" class="px-0 font-weight-bold" align="left"><h3>Plan Details</h3></v-col>
      <v-col cols="2" class="px-0 font-weight-bold" align="left"><h3>Price</h3></v-col>
    </v-row>
    <PetRow class="petrow px-0" v-for="(pet, i) in pets" :key="i" :pet="pet" />
    <v-row class="petrow px-0">
      <v-col class="px-0 py-1 pt-3" align="left" cols="10"><b>Subtotal</b> <span class="disclaimer">*Taxes may apply</span></v-col>
      <v-col class="px-0 py-1 pt-3" align="left" cols="2">${{ pets.reduce((total, pet) => total + parseFloat(pet.plan.costPerMonth), 0).toFixed(2) }}/mo*</v-col>
      <v-col class="px-0 py-1" align="left" cols="10"></v-col>
      <v-col class="px-0 py-1" align="left" cols="2"></v-col>
    </v-row>
    <v-row>
      <v-col class="px-0 mb-4" cols="10" align="left">
        <span class="font-weight-bold total">Total</span><br />
        <span class="disclaimer">*Requires 12 month minimum commitment</span>
      </v-col>
      <v-col class="px-0 font-weight-bold total" cols="2" align="left">
        ${{ pets.reduce((total, pet) => total + parseFloat(pet.plan.costPerMonth), 0).toFixed(2) }}/mo*
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
  h3 {
    color: $hpp-blue;
    font-size: 18px;
  }
  .petcontainer {
    padding-bottom: 0;
    font-size: 13px;
  }
  .petrow {
    border-bottom: solid 1px #E2E2E2;
  }
  .total {
    font-size: 18px;
  }
  .disclaimer {
    font-size: 11px;
  }
  .edit {
    text-decoration: underline;
    font-size: 13px;
  }
  @media only screen and (max-width: 960px) {
    h3 {
      font-size: 18px !important;
      line-height: 18px;
    }
  }
</style>
